<div [style]="safeCss(configData.css)">
    {{configData?.text || ''}}
</div>